import React, { useState, useEffect, useRef } from "react";
import { IoSearch } from "react-icons/io5";
import { MdKeyboardArrowRight } from "react-icons/md";

const TableContainer = ({
  data = [],
  columns = [],
  onRowSelect,
  onSelectionChange,
  selectedRows = [],
  onPageChange,
  onPageSizeChange,
  currentPage = 1,
  pageSize = 10,
  handleSearchLead,
  searchQuery,
  setSearchQuery,
  disPlay = false,
  isSearch = false,
  loading = false,
  nextPageToken = null,
  prevPageToken = null,
  hasMore = false,
  hidePagination = false,
}) => {
  const selectAllCheckboxRef = useRef(null);
  const selected = selectedRows || [];
  const allSelected =
    Array.isArray(data) &&
    data.length > 0 &&
    data.every((row) => selected.includes(row.id));
  const someSelected =
    Array.isArray(data) &&
    selected.length > 0 &&
    data.some((row) => selected.includes(row.id)) &&
    !allSelected;

  useEffect(() => {
    if (selectAllCheckboxRef.current) {
      selectAllCheckboxRef.current.indeterminate = someSelected;
    }
  }, [someSelected]);

  console.log("table " , hasMore)

  const handleSelectAll = (e) => {
    const currentPageIds = data.map((item) => item.id);
    if (e.target.checked) {
      const newSelected = [...new Set([...selected, ...currentPageIds])];
      onSelectionChange?.(newSelected, "all");
    } else {
      const newSelected = selected.filter((id) => !currentPageIds.includes(id));
      onSelectionChange?.(newSelected, null);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSelectRow = (id) => {
    let newSelected;
    if (selected.includes(id)) {
      newSelected = selected.filter((item) => item !== id);
    } else {
      newSelected = [...selected, id];
    }
    onSelectionChange?.(newSelected, id);
  };

  const renderCellContent = (column, row) => {
    const cellData = row[column.key];
    if (column.render) return column.render(cellData, row);
    if (Array.isArray(cellData)) {
      return cellData
        .map((item) => item.name || item.label || JSON.stringify(item))
        .join(", ");
    }
    if (typeof cellData === "object" && cellData !== null) {
      return cellData.name || cellData.label || JSON.stringify(cellData);
    }
    return cellData;
  };

  const handlePageSizeChange = (e) => {
    const newPageSize = parseInt(e.target.value, 10);
    onPageSizeChange(newPageSize);
  };

  return (
    <div className="w-full overflow-hidden rounded-lg shadow px-5 pt-4 bg-white">
      {isSearch && (
        <div className="flex items-center justify-between rounded-lg px-3 py-2 bg-[#F6F6F6]">
          <div className="flex items-center gap-8">
            <div className="flex items-center gap-3">
              <div className="relative w-[385px]">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
                  <IoSearch />
                </span>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={handleSearch}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearchLead();
                    }
                  }}
                  className="pl-10 pr-4 py-2 w-full border h-[49px] rounded-md input-focus"
                />
              </div>
              <button
                disabled={loading}
                onClick={handleSearchLead}
                className={`${
                  loading ? "bg-slate-400 cursor-not-allowed" : "bg-primary"
                } w-[131px] h-[50px] rounded-[10px] text-white`}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="overflow-x-auto">
      <table className="min-w-full mt-[4px]">
        <thead>
          <tr className="bg-[#F6F6F6]">
            {disPlay && (
              <th className="p-4 rounded-tl-[15px]">
                <input
                  type="checkbox"
                  ref={selectAllCheckboxRef}
                  checked={allSelected}
                  onChange={handleSelectAll}
                  className="form-checkbox h-4 w-4 text-blue-600"
                />
              </th>
            )}
            {columns.map((column, index) => {
              const isFirst = index === 0 && !disPlay;
              const isLast = index === columns.length - 1;
              return (
                <th
                  key={column.key}
                  className={`p-4 text-center text-sm font-medium text-gray-600 whitespace-nowrap ${
                    isFirst ? "rounded-tl-[15px] rounded-bl-[15px]" : ""
                  } ${isLast ? "rounded-tr-[15px] rounded-br-[15px]" : ""}`}
                  style={{ width: column.width }}
                >
                  {column.title}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {!loading &&
            Array.isArray(data) &&
            data.map((row) => {
              const isItemSelected = selected.includes(row.id);
              return (
                <tr
                  key={row.id}
                  className={`border-b hover:bg-gray-50 ${
                    isItemSelected
                      ? "bg-blue-50 border-l-4 border-blue-500"
                      : ""
                  }`}
                  onClick={() => onRowSelect?.(row)}
                >
                  {disPlay && (
                    <td className="p-4">
                      <input
                        type="checkbox"
                        checked={isItemSelected}
                        onChange={() => handleSelectRow(row.id)}
                        onClick={(e) => e.stopPropagation()}
                        className="form-checkbox h-4 w-4 text-blue-600"
                      />
                    </td>
                  )}
                  {columns.map((column) => (
                    <td
                      key={`${row.id}-${column.key}`}
                      className="p-4 text-center"
                    >
                      {renderCellContent(column, row)}
                    </td>
                  ))}
                </tr>
              );
            })}
          {loading && (
            <tr>
              <td
                colSpan={columns.length + (disPlay ? 1 : 0)}
                className="p-4 text-center"
              >
                <div className="flex justify-center items-center h-full">
                  <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary"></div>
                </div>
              </td>
            </tr>
          )}
          {!loading && Array.isArray(data) && data.length === 0 && (
            <tr>
              <td
                colSpan={columns.length + (disPlay ? 1 : 0)}
                className="p-4 text-center"
              >
                <div className="flex flex-col items-center justify-center space-y-4">
                  <div className="text-primary font-semibold mt-[20px]">
                    No Data Available
                  </div>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
      {!hidePagination && <div className="flex items-center justify-between border-t p-4 px-3">
        <div className="text-sm text-gray-500">
          <select
            className="border rounded p-2"
            onChange={handlePageSizeChange}
            value={pageSize}
          >
             {/* <option value="4">1 - 4</option> */}
            <option value="10">1 - 10</option>
            <option value="50">1 - 50</option>
            <option value="100">1 - 100</option>
          </select>
        </div>
        <div className="flex justify-center my-5 gap-1">
          {currentPage > 1 && (
            <button
              onClick={() => onPageChange(prevPageToken, "previous")}
              className="mx-1 p-2 min-w-[40px] min-h-[40px] border rounded-[10px] border-primary cursor-pointer"
              aria-label="Go to previous page"
              disabled={loading}
            >
              <MdKeyboardArrowRight className="text-primary text-2xl transform rotate-180 transition-transform duration-300" />
            </button>
          )}
          <div className="bg-primary shadow-lg mx-1 p-2 min-w-[40px] min-h-[40px] border border-primary text-center text-white rounded-[10px]">
            {currentPage}
          </div>
          <button
  onClick={() => onPageChange(nextPageToken, "next")}
  className={`mx-1 p-2 min-w-[40px] min-h-[40px] border rounded-[10px] transition duration-300 ${
    hasMore ? "border-primary cursor-pointer" : "border-gray-300 cursor-not-allowed"
  }`}
  aria-label="Go to next page"
  disabled={!hasMore || loading}
>
  <MdKeyboardArrowRight className={`text-2xl ${
   hasMore && !loading ? "text-primary" : "text-gray-400"
  }`} />
</button>
        </div>
      </div>}
    </div>
  );
};

export default TableContainer;
